import React, { useEffect } from "react";
import { OnboardingAxios, ProgramSetupAxios } from "../../../../API";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Registrations from "./Registrations";
import BasicUsage from "./BasicUsage";

const Reports = (props) => {
    const [key, setKey] = React.useState('registration');
    return (
        <>
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >
                <Tab eventKey="registration" title="Registrations">
                    <Registrations offeringList={props.offeringList} selectedOffering={props.selectedOffering} selectedOfferingName={props.selectedOfferingName} />
                </Tab>
                <Tab eventKey="basicUsage" title="Basic Usage">
                    <BasicUsage offeringList={props.offeringList} selectedOffering={props.selectedOffering} selectedOfferingName={props.selectedOfferingName} />
                </Tab>
            </Tabs>
        </>
    );
};

export default Reports;
